import { NAME as PARENT_NAME, ROUTES as PARENT_ROUTES } from '../constants';

export const NAME = `${PARENT_NAME}/ADD_SHIPMENT`;

export const REDUCER_NAME = 'itineraryAttachment';

export const FORM_NAME = NAME;

export const ROUTES = {
  ROOT: `${PARENT_ROUTES.ROOT}/itineraryAttachment`,
};

const EDGE = OPERATIONS_EDGE;

export const API = {
  ALL: `${EDGE}/api/shipments/manifest/mw`,
  ALL_SHIPMENTS: `${EDGE}/api/shipments?queryLMOnly=true&manifestType=LAST_MILE`,
};
